module.exports = __webpack_public_path__ + "ae262f47141d459cf500502784f7b3e0.ttf";


//////////////////
// WEBPACK FOOTER
// ./libs/font-awesome/webfonts/fa-solid-900.ttf
// module id = 356
// module chunks = 0